import { useT } from '../../i18n/i18n';
import type { CloudState } from '../../state/reportCloudStore';

// Why delivered PDFs are still waiting to be copied to the account (Owner decision list 2026-10-19 item 25).
// The PDFs are on the device either way; the copy is retried on its own.
export function CloudNote(props: { state: CloudState }) {
  const { t } = useT();
  const key = props.state === 'offline' ? 'cloud.noteOffline' : props.state === 'notConfigured' ? 'cloud.noteNotConfigured' : props.state === 'unavailable' ? 'cloud.noteUnavailable' : null;
  return key ? (
    <p className="cloud-note" data-testid="cloud-note" data-state={props.state}>
      {t(key)}
    </p>
  ) : null;
}
